module.exports = __webpack_public_path__ + "img/IMG_1962_P_BlackMatted_MockedUp.145134b3.jpg";